import './i18n.js';

/**
 * Import example blocks
 */
import './blocks/product';
import './blocks/domain-search';
